import React, { useState } from "react";
import { Box } from "@mui/material";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";

interface Props {
  src?: string;
  /** Shown if `src` is missing or fails to load (e.g. a generated tile). */
  fallback?: string;
  alt?: string;
  size?: number | string;
  radius?: number;
}

/** Product thumbnail: real image → fallback image → placeholder icon. */
const ProductImage: React.FC<Props> = ({ src, fallback, alt, size = "100%", radius = 8 }) => {
  const [broken, setBroken] = useState(false);
  const effective = src && !broken ? src : fallback;
  return (
    <Box
      sx={{
        width: size, aspectRatio: "1 / 1", borderRadius: `${radius}px`,
        overflow: "hidden", bgcolor: "#f1f4f2", display: "grid", placeItems: "center",
        color: "#b7c2bb",
      }}
    >
      {effective ? (
        <Box component="img" src={effective} alt={alt}
          onError={() => { if (src && !broken) setBroken(true); }}
          sx={{ width: "100%", height: "100%", objectFit: "cover" }} />
      ) : (
        <ImageOutlinedIcon />
      )}
    </Box>
  );
};

export default ProductImage;
